import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { SimpleSelect } from 'react-selectize-advizr';
import { createCustomPropType, isNumeric, isUuid } from '../../../../js/app/react/validators';
import AdvForm from '../../../CommonComponents/AdvForm';
import { simpleSelectDefaultValue } from '../../../Profile/Accounts_react/AccountsUtils';
import Footer from '../../Footer/FooterContainer';
import Loading from '../../Loading/LoadingView';
import PlanImpact from '../../PlanImpact/PlanImpactContainer';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';

const dafSelectDefaultValue = (options, selectedObj) => {
  if (!selectedObj) return null;
  return (
    options.find(opt => opt.value === selectedObj.Year && opt.type === selectedObj.Type) || null
  );
};

const isNumericOrNull = value => value === null || isNumeric(value);

class DonationYearView extends Component {
  componentDidMount() {
    const {
      fetchData,
      clientId,
      fpId,
      goalId,
      fetchInitialPlanImpact,
      whatIf,
      whatIfTemplate,
    } = this.props;

    fetchData(clientId, fpId, goalId, whatIfTemplate.WhatIfType);
    fetchInitialPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
  }

  componentDidUpdate(prevProps) {
    const { clientId, fpId, goalId, whatIf, fetchPlanImpact, whatIfTemplate } = this.props;
    const impactTriggerProps = ['whatIf'];

    if (!isEqual(pick(this.props, impactTriggerProps), pick(prevProps, impactTriggerProps))) {
      fetchPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
    }
  }

  render() {
    const {
      clientId,
      fpId,
      goalId,
      loading,
      title,
      groupTitle,
      whatIf,
      whatIfTemplate,
      applyWhatIf,
      areOptionsLoaded,
      planImpactItems,
      onYearChange,
      yearsOptions,
      dafStartYearOptions,
      dafEndYearOptions,
      donationStartYear,
      donationEndYear,
      dafDonationStartYear,
      dafDonationEndYear,
      dafGrantStartYear,
      dafGrantEndYear,
      storeData,
      isRecurring,
    } = this.props;
    return (
      <div className="what-ifs-layout">
        {loading && <Loading />}
        <div className="what-ifs-section what-ifs-layout-header">
          <h3>What-If...</h3>
        </div>
        <div className="what-ifs-layout-content">
          <h4 className="what-if-group-title">{groupTitle}</h4>
          <AdvForm>
            <ValidationErrors clientId={clientId} />
            <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
              <li className="what-ifs-form-field">
                <h5 className="what-if-title">{title}</h5>
              </li>
              {yearsOptions.length > 0 && (
                <>
                  <li className="what-ifs-form-field">
                    <label className="what-if-label">
                      {isRecurring ? 'Start Year' : 'Donation Year'}
                    </label>
                    <SimpleSelect
                      className="what-ifs-simple-select"
                      value={simpleSelectDefaultValue(yearsOptions, donationStartYear)}
                      onValueChange={selectedOption => {
                        onYearChange(
                          clientId,
                          goalId,
                          whatIfTemplate.WhatIfType,
                          'DonationStartYear',
                          selectedOption,
                        );
                      }}
                      options={yearsOptions}
                      renderOption={({ label, rightLabel }) => (
                        <div className="what-ifs-year-option">
                          <span className="what-ifs-year-label">{label}</span>
                          {rightLabel && (
                            <span className="what-ifs-year-right-label">{rightLabel}</span>
                          )}
                        </div>
                      )}
                      renderValue={({ label }) => (
                        <div className="what-ifs-year-option-selected">
                          <span className="what-ifs-year-selected-label">{label}</span>
                        </div>
                      )}
                    />
                  </li>
                  {isRecurring && (
                    <li className="what-ifs-form-field">
                      <label className="what-if-label">End Year</label>
                      <SimpleSelect
                        className="what-ifs-simple-select"
                        value={simpleSelectDefaultValue(yearsOptions, donationEndYear)}
                        onValueChange={selectedOption => {
                          onYearChange(
                            clientId,
                            goalId,
                            whatIfTemplate.WhatIfType,
                            'DonationEndYear',
                            selectedOption,
                          );
                        }}
                        options={yearsOptions}
                        renderOption={({ label, rightLabel }) => (
                          <div className="what-ifs-year-option">
                            <span className="what-ifs-year-label">{label}</span>
                            {rightLabel && (
                              <span className="what-ifs-year-right-label">{rightLabel}</span>
                            )}
                          </div>
                        )}
                        renderValue={({ label }) => (
                          <div className="what-ifs-year-option-selected">
                            <span className="what-ifs-year-selected-label">{label}</span>
                          </div>
                        )}
                      />
                    </li>
                  )}
                  <li className="what-ifs-form-field what-ifs-form-field-no-box">
                    <label htmlFor="IsRecurring" className="what-ifs-age-label what-ifs-checkbox">
                      <input
                        type="checkbox"
                        id="IsRecurring"
                        className="what-ifs-checkbox-toggle"
                        checked={isRecurring}
                        onChange={event => {
                          const checked = event.target.checked;
                          storeData(goalId, whatIfTemplate.WhatIfType)(
                            {
                              WhatIf: {
                                IsRecurring: checked,
                                DonationEndYear: checked ? donationEndYear : null,
                              },
                            },
                            clientId,
                          );
                        }}
                      />
                      <i className="what-ifs-checkbox-mark" />
                      <span className="what-ifs-checkbox-label-text">Recurring</span>
                    </label>
                  </li>
                </>
              )}

              {dafStartYearOptions.length > 0 && (
                <>
                  <li className="what-ifs-form-field">
                    <label className="what-if-label">DAF Donation Start Year</label>
                    <SimpleSelect
                      className="what-ifs-simple-select"
                      value={dafSelectDefaultValue(dafStartYearOptions, dafDonationStartYear)}
                      onValueChange={selectedOption =>
                        onYearChange(
                          clientId,
                          goalId,
                          whatIfTemplate.WhatIfType,
                          'DafDonationStartYear',
                          selectedOption,
                        )
                      }
                      options={dafStartYearOptions}
                      placeholder="Select Donation Start Year"
                      renderOption={({ label, rightLabel }) => (
                        <div className="what-ifs-year-option">
                          <span className="what-ifs-year-label">{label}</span>
                          {rightLabel && (
                            <span className="what-ifs-year-right-label">{rightLabel}</span>
                          )}
                        </div>
                      )}
                      renderValue={({ label }) => (
                        <div className="what-ifs-year-option-selected">
                          <span className="what-ifs-year-selected-label">{label}</span>
                        </div>
                      )}
                    />
                  </li>
                  <li className="what-ifs-form-field">
                    <label className="what-if-label">DAF Donation End Year</label>
                    <SimpleSelect
                      className="what-ifs-simple-select"
                      value={dafSelectDefaultValue(dafEndYearOptions, dafDonationEndYear)}
                      onValueChange={selectedOption =>
                        onYearChange(
                          clientId,
                          goalId,
                          whatIfTemplate.WhatIfType,
                          'DafDonationEndYear',
                          selectedOption,
                        )
                      }
                      options={dafEndYearOptions}
                      placeholder="Select Donation End Year"
                      renderOption={({ label, rightLabel }) => (
                        <div className="what-ifs-year-option">
                          <span className="what-ifs-year-label">{label}</span>
                          {rightLabel && (
                            <span className="what-ifs-year-right-label">{rightLabel}</span>
                          )}
                        </div>
                      )}
                      renderValue={({ label }) => (
                        <div className="what-ifs-year-option-selected">
                          <span className="what-ifs-year-selected-label">{label}</span>
                        </div>
                      )}
                    />
                  </li>
                  <li className="what-ifs-form-field">
                    <label className="what-if-label">Grant Start Year(Optional)</label>
                    <SimpleSelect
                      className="what-ifs-simple-select"
                      value={dafSelectDefaultValue(dafStartYearOptions, dafGrantStartYear)}
                      onValueChange={selectedOption =>
                        onYearChange(
                          clientId,
                          goalId,
                          whatIfTemplate.WhatIfType,
                          'DafGrantStartYear',
                          selectedOption,
                        )
                      }
                      options={dafStartYearOptions}
                      placeholder="Select Grant Start Year"
                      renderOption={({ label, rightLabel }) => (
                        <div className="what-ifs-year-option">
                          <span className="what-ifs-year-label">{label}</span>
                          {rightLabel && (
                            <span className="what-ifs-year-right-label">{rightLabel}</span>
                          )}
                        </div>
                      )}
                      renderValue={({ label }) => (
                        <div className="what-ifs-year-option-selected">
                          <span className="what-ifs-year-selected-label">{label}</span>
                        </div>
                      )}
                    />
                  </li>
                  <li className="what-ifs-form-field">
                    <label className="what-if-label">Grant End Year(Optional)</label>
                    <SimpleSelect
                      className="what-ifs-simple-select"
                      value={dafSelectDefaultValue(dafEndYearOptions, dafGrantEndYear)}
                      onValueChange={selectedOption =>
                        onYearChange(
                          clientId,
                          goalId,
                          whatIfTemplate.WhatIfType,
                          'DafGrantEndYear',
                          selectedOption,
                        )
                      }
                      options={dafEndYearOptions}
                      placeholder="Select Grant End Year"
                      renderOption={({ label, rightLabel }) => (
                        <div className="what-ifs-year-option">
                          <span className="what-ifs-year-label">{label}</span>
                          {rightLabel && (
                            <span className="what-ifs-year-right-label">{rightLabel}</span>
                          )}
                        </div>
                      )}
                      renderValue={({ label }) => (
                        <div className="what-ifs-year-option-selected">
                          <span className="what-ifs-year-selected-label">{label}</span>
                        </div>
                      )}
                    />
                  </li>
                </>
              )}
            </ul>
          </AdvForm>
        </div>
        <PlanImpact clientId={clientId} planImpactItems={planImpactItems} />
        <Footer
          clientId={clientId}
          applyToPlanCallback={applyWhatIf(clientId, fpId, goalId, whatIf, whatIfTemplate)}
        />
      </div>
    );
  }
}

DonationYearView.defaultProps = {
  title: 'Untitled Donation What-If',
  groupTitle: 'Charitable Giving',
};

DonationYearView.propTypes = {
  planImpactItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      current: PropTypes.string.isRequired,
      proposed: PropTypes.string.isRequired,
    }),
  ).isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  areOptionsLoaded: PropTypes.bool.isRequired,
  whatIf: PropTypes.shape({}).isRequired,
  whatIfTemplate: PropTypes.shape({}).isRequired,
  fetchData: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchInitialPlanImpact: PropTypes.func.isRequired,
  fetchPlanImpact: PropTypes.func.isRequired,
  applyWhatIf: PropTypes.func.isRequired,
  onYearChange: PropTypes.func.isRequired,
  yearsOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  dafStartYearOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  donationStartYear: createCustomPropType(isNumericOrNull),
  donationEndYear: createCustomPropType(isNumericOrNull),
  dafDonationStartYear: PropTypes.shape({
    Year: PropTypes.oneOfType([PropTypes.number, PropTypes.null]),
    Type: PropTypes.number,
  }),
  storeData: PropTypes.func.isRequired,
};

export default DonationYearView;
